var CartSummary = (function ($) {

    function updateCartSummary(cartSummaryData) {
        var $cartSummaryContainer = $(".cart-summary-header");
        $cartSummaryContainer.empty();
        $cartSummaryContainer.html(cartSummaryData);
        initResizeListeners();
    }

    function handleAddToCartEvent() {
        $(document).on("changeCartEvent", function (event, data) {
            $.ajax({
                url: "/cart/summary",
                type: "GET",
                cache: false,
                success: function (cartSummaryData) {
                    updateCartSummary(cartSummaryData);
                }
            });
        });
    }

    function customAddClass() {
        $('.cart-summary-popup-container.cart-summary-pop-up-show').addClass('hovering');
        $('.header-link__cart-link.cart-summary-pop-up-show').addClass('hovering');
    }

    function customRemoveClass() {
        $('.cart-summary-popup-container.cart-summary-pop-up-show').removeClass('hovering');
        $('.header-link__cart-link.cart-summary-pop-up-show').removeClass('hovering');
    }

    function initResizeListeners() {

        if (!IsMobile){
            return;
        }

        if (IsMobile.any()) {

            $(window).on('resize', function () {
                popoverPosition();
            });

            $('.header-link__cart-link.cart-summary-pop-up-show').on('click', function () {
                if (event.target.classList[0] === 'header-link__cart-link' ||
                    event.currentTarget.className.includes('header-link__cart-link')) {

                    var $cartSummaryPopUp = $('.cart-summary-popup-container.cart-summary-pop-up-show');

                    if (!$('.cart-summary-popup-container').find('.close-tooltip')[0]) {
                        $cartSummaryPopUp.append('<span class="close-tooltip">x</span>');
                    }

                    $cartSummaryPopUp.toggleClass('hovering');

                    popoverPosition();

                    $('.close-tooltip').on('click', function () {
                        customRemoveClass();
                    });
                    return false;
                }
            });
        } else {
            $('.cart-summary-view.header-link__cart.delti_cart_summary.cart-summary-header')
                .on('mouseenter', function () {
                    customAddClass();
                });

            $('.cart-summary-popup-container.cart-summary-pop-up-show')
                .on('mouseenter', function () {
                    customAddClass();
                })
                .on('mouseleave', function (event) {
                    if (event.relatedTarget === null) {
                        return;
                    }
                    customRemoveClass();
                });
        }
    }

    function popoverPosition() {
        var $cartSummary = $('.cart-summary-view');
        var $cartSummaryPopUp = $('.cart-summary-popup-container');
        if ($cartSummary.length > 1) {
            $cartSummary = $('.mobile-cart-summary-header .cart-summary-view');
            $cartSummaryPopUp = $('.mobile-cart-summary-header .cart-summary-popup-container');
        }
        if ($cartSummaryPopUp.length > 0) {
            var popupPosition = ($cartSummary.offset().left + $cartSummary.innerWidth()) < $cartSummaryPopUp.innerWidth()
                ? ($cartSummary.offset().left + $cartSummary.innerWidth() - $cartSummaryPopUp.innerWidth() + "px")
                : "0";
            $cartSummaryPopUp.css({
                "right" : popupPosition
            });
        }
    }

    var removeProductPressed = function(button) {
        var selectedEntry = $(button);
        var productCode =  selectedEntry.closest(".remove-article-wrapper").find("input[name='productCode']").val();
        $.ajax({
            url: "/removefromcartsummary",
            type: "GET",
            data: {code: productCode},
            success: function(data) {
                $( document ).trigger("changeCartEvent");
                if (data.totalQuantity === 0) {
                    $(".main-page-header-container")[0].classList.remove("has-order");
                    $(".order-now-container").hide();
                    $(".language-selector").show();
                }
            }
        });
    };

    var updateQuantity = function(select) {
        var selectedQuantity = $(select);
        var index =  selectedQuantity.closest(".product-count").find("input[name='productIndex']").val();
        var quantity = selectedQuantity.val();
        $.ajax({
            url: "/updatecartsummaryquantity",
            type: "GET",
            data: {index: index, quantity: quantity},
            success: function() {
                $( document ).trigger( "changeCartEvent");
            }
        });
    };

    return {
        initResizeListeners: initResizeListeners,
        updateCartSummary: updateCartSummary,
        handleAddToCartEvent: handleAddToCartEvent,
        removeProductPressed: removeProductPressed,
        updateQuantity: updateQuantity
    };

})(jQuery);

$(document).ready(function () {
    CartSummary.initResizeListeners();
    CartSummary.handleAddToCartEvent();
});